import { render, staticRenderFns } from "./dvr-loader.vue?vue&type=template&id=1f9b1b68&scoped=true"
import script from "./dvr-loader.vue?vue&type=script&lang=js"
export * from "./dvr-loader.vue?vue&type=script&lang=js"
import style0 from "./dvr-loader.vue?vue&type=style&index=0&id=1f9b1b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b1b68",
  null
  
)

export default component.exports